function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16.0926 3.7254C17.5919 5.18048 18.5611 6.8256 18.9773 7.61541C18.0583 9.09182 15.019 13.214 9.99983 13.214C4.98064 13.214 1.94139 9.09181 1.02234 7.61541C1.43853 6.8256 2.40779 5.18048 3.90706 3.7254C5.44999 2.22795 7.47989 1 9.99983 1C12.5198 1 14.5497 2.22795 16.0926 3.7254ZM19.9017 7.22513C20.0421 7.49556 20.0311 7.81012 19.8719 8.06994C18.988 9.51307 15.6732 14.214 9.99983 14.214C4.32643 14.214 1.01165 9.51307 0.127728 8.06994C-0.031415 7.81012 -0.0424223 7.49556 0.0979486 7.22513C0.93507 5.61242 4.26062 0 9.99983 0C15.739 0 19.0646 5.61242 19.9017 7.22513ZM13.5964 7.1083C13.5964 8.97718 12.0187 10.5502 9.99974 10.5502C7.98077 10.5502 6.40304 8.97718 6.40304 7.1083C6.40304 5.23942 7.98077 3.66642 9.99974 3.66642C12.0187 3.66642 13.5964 5.23942 13.5964 7.1083ZM14.5964 7.1083C14.5964 9.56149 12.5384 11.5502 9.99974 11.5502C7.46105 11.5502 5.40304 9.56149 5.40304 7.1083C5.40304 4.65512 7.46105 2.66642 9.99974 2.66642C12.5384 2.66642 14.5964 4.65512 14.5964 7.1083Z",
  fill: "#767B87"
});

const SvgView = (_ref) => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 20,
    height: 15,
    viewBox: "0 0 20 15",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgView, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/view.96460d77.svg";
export { ForwardRef as ReactComponent };